import { createSlice } from '@reduxjs/toolkit';
import { mergeNationCode } from 'utils/common';

const signupSlice = createSlice({
  name: 'signup',
  initialState: {
    currentStep: 1,
    locale: 'ko',
    option: 'mobile',
    userIdRadio: 'firstUserIdRadio',
    register: false,
    globalPosition: 'KR',
    pslInfoAgmtYn: null,
    telCodeList: [],
    addressNationList: [],
    emp: {},
    isPassStep1: false,
    isPassOTP: false,
    isShowAgreement: false,
    isPassAgreement: false,
    isPassStep2: false,
    isPassDuplicationId: false,
    isPassStep3: false,
    checkedUserId: '',
  },
  reducers: {
    getNoSessionRegister: () => {},
    getNoSessionRegisterSuccess: (state, { payload }) => {
      state.register = payload.value === 'Y';
    },
    getNoSessionGlobalPosition: () => {},
    getNoSessionGlobalPositionSuccess: (state, { payload }) => {
      state.globalPosition = payload.value;
    },
    nextStep: state => {
      state.currentStep += 1;
    },
    setLocale: (state, { payload }) => {
      state.locale = payload;
    },
    setOption: (state, { payload }) => {
      state.option = payload;
    },
    setUserIdRadio: (state, { payload }) => {
      state.userIdRadio = payload;
    },
    setPslInfoAgmtYn: (state, { payload }) => {
      state.pslInfoAgmtYn = payload;
    },
    getTelCodeList: () => {},
    getTelCodeListSuccess: (state, { payload }) => {
      state.telCodeList = mergeNationCode(payload);
    },
    getAddressNationList: () => {},
    getAddressNationListSuccess: (state, { payload }) => {
      state.addressNationList = payload;
    },
    addEmp: () => {},
    addEmpSuccess: (state, { payload }) => {
      state.isPassStep1 = true;
      state.emp = payload;
    },
    setIsPassStep1Cancel: state => {
      state.isPassStep1 = false;
    },
    getCheckOTP: () => {},
    getCheckOTPSuccess: (state, { payload }) => {
      state.isPassOTP = payload;
    },
    setIsShowAgreement: (state, { payload }) => {
      state.isShowAgreement = payload;
    },
    setIsPassAgreement: (state, { payload }) => {
      state.isPassAgreement = payload;
    },
    getDoubleCheck: (state, { payload }) => {
      state.checkedUserId = payload.query;
    },
    getDoubleCheckSuccess: (state, { payload }) => {
      state.isPassDuplicationId = payload;
    },
    getDoubleCheckFail: state => {
      state.isPassDuplicationId = false;
    },
    getValidate: () => {},
    getValidateSuccess: (state, { payload }) => {
      state.isPassStep2 = payload;
    },
    setUserId: (state, { payload }) => {
      state.emp.userId = payload;
    },
    modifyEmp: () => {},
    modifyEmpSuccess: (state, { payload }) => {
      state.isPassStep3 = payload;
    },
  },
});

export const {
  getNoSessionRegister,
  getNoSessionRegisterSuccess,
  getNoSessionGlobalPosition,
  getNoSessionGlobalPositionSuccess,
  nextStep,
  setLocale,
  setOption,
  setUserIdRadio,
  setPslInfoAgmtYn,
  getTelCodeList,
  getTelCodeListSuccess,
  getAddressNationList,
  getAddressNationListSuccess,
  addEmp,
  addEmpSuccess,
  setIsPassStep1Cancel,
  getCheckOTP,
  getCheckOTPSuccess,
  setIsShowAgreement,
  setIsPassAgreement,
  getDoubleCheck,
  getDoubleCheckSuccess,
  getDoubleCheckFail,
  getValidate,
  getValidateSuccess,
  setUserId,
  modifyEmp,
  modifyEmpSuccess,
} = signupSlice.actions;

export default signupSlice.reducer;
